export enum WageTriggerFilter {
  Always = 0,
  Miles = 1
}

export const WageTriggerFilterMapping: Record<WageTriggerFilter, string> = {
  [WageTriggerFilter.Always]: 'Always',
  [WageTriggerFilter.Miles]: 'Miles'
};
